// formik components
import { ErrorMessage, Field } from "formik";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Declaring props types for FormField
interface Props {
  label: string;
  name: string;
  options: Array<{ value: string; label: string }>;
  [key: string]: any;
}

function FormSelect({ label, name, ...rest }: Props): JSX.Element {
  return (
    <MDBox mb={1.5}>
      <Field
        {...rest}
        name={name}
        as="select"
        variant="standard"
        label={label}
        style={{
          width: "95%",
          minHeight: "30px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          textAlign: "left",
          fontSize: "1rem",
          fontWeight: "bold",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          paddingLeft: "10px",
        }}
      >
        {rest.options.map((option, i) => (
          <option key={`${name}-option-${i}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </Field>
      <MDBox mt={0.75}>
        <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
          {(<ErrorMessage name={name} />) as any}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

export default FormSelect;
